import 'react-app-polyfill/ie11';
import 'react-app-polyfill/stable';
import './global.css';
import './functions/tracing';

const banner = `
         #####            
     ##############       
   ###################     
 ######################     #########                   #####                               ###          
########################    ###   ####                 #####                                ###           
#########      #########    ###    ###                 ###                                                
########        ########    ###   #### ######  ####### ###### ######  ####### ############  ###  ######   
                ########    ######### ###  ### #####   ###   ######## ####    ### #### #### ### ########  
##########    ##########    ###       ######## ###     ###   ###  ### ###     ###  ###  ### ### ###  ###  
 ########   ###########     ###       ####     ###     ###   ######## ###     ###  ###  ### ### ########  
   #####   ##########       ###        ######  ###     ###    ######  ###     ###  ###  ### ###  ######   
     ##   #########       
          #####`;

(async function bootstrap() {
  const appVersion = document
    .querySelector("meta[name='version']")
    ?.getAttribute('content')
    ?.replace('Version', '')
    .trim();

  const env = IS_PRODUCTION ? 'production' : IS_DEV ? 'development' : 'unknown';

  // Display console banner message
  console.log(
    `${banner}\n\nVersion: ${
      appVersion ?? 'Unknown'
    } (JSBundle: ${VERSION}-${env})\n\n`,
  );

  const { default: init } = await import(
    /* webpackChunkName: "viewLoader" */ /* webpackPreload: true */ './viewLoader'
  );
  init();
})();
